import { Injectable } from '@angular/core';
import { RequestOptions, URLSearchParams } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AppSettings } from './../app.settings';
import { UserService } from './user.service';
import { CommonRequestService, PagingParam } from './common-request.service';
import { Gfo } from './common-gfo.service';
import { count } from 'console';

export interface NagCategory {
	id: number;
	name: string;
	desc: string;
	parentId: number;
	isSpatial: boolean;
	parentCate: string;
}
export interface NagPlaceType {
	id: number;
	name: string;
	desc: string;
}
// export interface NagNamesStandard {
// 	id: number;
// 	name: string;
// 	parentName: string;
// 	geom: any; // TODO
// 	centroid: string; // TODO: ???
// }
export interface NagNameAlias {
	id: number;
	name: string;
	stnId: number; // standard name id
}

@Injectable()
export class A3iNagService {

	constructor(
		private requestService: CommonRequestService
	) { }

	getNagCategories(skipAuth?: boolean): Promise<NagCategory[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagCategory';
			this.requestService.requestGet(url, null,
				(rsp) => {
					const nagCates: NagCategory[] = [];
					if (rsp.data) {
						rsp.data.forEach((d) => {
							nagCates.push({
								id: d.nct_id,
								name: d.nct_name,
								desc: d.nct_desc,
								parentId: d.nct_parent_id,
								parentCate: d.parent_category,
								isSpatial: d.nct_is_spatial
							});
						});
					}
					resolve(nagCates);
				}, (err) => {
					reject(err);
				}, skipAuth);
		});
	}

	getNagSubCategory(): Promise<NagPlaceType[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagSubCategory';
			this.requestService.requestGet(url, null, (rsp) => {
				const subs: NagPlaceType[] = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						subs.push({
							id: d.nsg_id,
							name: d.nsg_name,
							desc: d.nsg_desc
						});
					});
				}
				resolve(subs);
			}, (err) => reject(err));
		});
	}

	getNagNamesStandard(cateId: number, gfo?: Gfo, paging?: PagingParam, countryCode?: string, skipAuth?: boolean): Promise<{
		data: any[],
		totalCount?: number
	}> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesStandard';
			const params: URLSearchParams = new URLSearchParams();
			const options: RequestOptions = new RequestOptions();
			params.set('nctId', cateId.toString());
			if (gfo) {
				params.set('gfo', JSON.stringify(gfo));
			}
			if (paging) {
				this.requestService.setParamsPaging(params, paging);
			}
			if (countryCode) {
				params.set('countryCode', countryCode);
			}
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				// TODO
				resolve({
					data: rsp.data,
					totalCount: rsp.totalCount
				});
			}, (err) => {
				reject(err);
			}, skipAuth);
		});
	}

	getNagNamesAlias(standardId: number): Promise<NagNameAlias[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesAlias';
			const params: URLSearchParams = new URLSearchParams();
			const options: RequestOptions = new RequestOptions();
			params.set('id', standardId.toString());
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				const aliasList: NagNameAlias[] = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						aliasList.push(({
							id: d.aln_id,
							name: d.aln_name,
							stnId: d.aln_stn_id
						}));
					});
				}
				resolve(aliasList);
			}, (err) => {
				reject(err);
			});
		});
	}

	getNagNamesAliasState(cateId: number, countryCode: string, skipAuth?: boolean): Promise<NagNameAlias[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesAliasState';
			const params: URLSearchParams = new URLSearchParams();
			const options: RequestOptions = new RequestOptions();
			params.set('nctId', cateId.toString());
			params.set('countryCode', countryCode);
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				resolve(rsp.data ? rsp.data : []);
			}, (err) => {
				reject(err);
			}, skipAuth);
		});
	}

	// Add a standard name
	addStandard(categoryId: number, standardName: string, subCates: string[], parentId?: number): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesStandard';
			const body: any = {
				cateId: categoryId,
				stnName: standardName,
				subcates: JSON.stringify(subCates)
			};
			if (parentId || parentId === 0) {
				body.stnParentId = parentId;
			}
			this.requestService.requestPost(url, body, () => resolve(), (err) => reject(err));
		});
	}
	// Edit a standard name
	editStandard(standardId: number, standardName: string, subCates?: string[], parentId?: number): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesStandard';
			const body: any = {
				stnId: standardId,
				stnName: standardName,
				subcates: JSON.stringify(subCates)
			};
			if (parentId || parentId === 0) {
				body.stnParentId = parentId;
			}
			this.requestService.requestPut(url, body, () => resolve(), (err) => reject(err));
		});
	}
	// Remove a standard name
	deleteStandard(standardId: number): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesStandard';
			const body = {
				stnId: standardId
			};
			const options = new RequestOptions({
				body: body
			});
			this.requestService.requestDelete(url, options, () => resolve(), (err) => reject(err));
		});
	}
	// Add an alias
	addAlias(standardId: number, aliasName: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesAlias';
			const body: any = {
				stnId: standardId,
				alnName: aliasName
			};
			this.requestService.requestPost(url, body, () => resolve(), (err) => reject(err));
		});
	}
	// Edit an alias
	editAlias(aliasId: number, aliasName: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesAlias';
			const body = {
				alnId: aliasId,
				alnName: aliasName
			};
			this.requestService.requestPut(url, body, (rsp) => resolve(), (err) => reject(err));
		});
	}
	// Remove an alias
	deleteAlias(aliasId: number): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/nagNamesAlias';
			const body = {
				alnId: aliasId
			};
			const options = new RequestOptions({
				body: body
			});
			this.requestService.requestDelete(url, options, () => resolve(), (err) => reject(err));
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/a3i-nag.service.ts